(function($) {
  var parent = $('.radio_buttons').parents('.col-span-2')
  parent.wrapAll('<div class="radio_container">');

  var urlParams = new URLSearchParams(window.location.search); //get all parameters
  var foo = urlParams.get('contact_posted'); //extract the foo parameter - this will return NULL if foo isn't a parameter
  
  if(foo == 'true' ) { //check if foo parameter is set to anything
     $('modal-opener[data-modal="modal-customization-inquiry"]').find('.btn').click();
  }


  
  $('.achores-container .btn').each(function() {
    $(this).on('click', function(e) {
       e.preventDefault()
      var target = $(this).data('target');
      target = '#' + target;
      
      $([document.documentElement, document.body]).animate({
          scrollTop: $(target).offset().top - 130
      }, 400);
    });
  });
  
  $('.cb-product-benefits-container').flickity({
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    groupCells: 3,
    autoPlay: 1500
  });
  
  $('.tier-item').each(function() {

    let _thisTierItem = this;

    $(this).find('label').on('click', function() {
      
      if ($(this).parents('.tier-item').hasClass('current')) {
        $(this).parents('.tier-item').removeClass('selected current');
        $(this).siblings('input').prop('checked', false);
        $(this).parents('.tier-pricing-block').find('.progress-line div').css('width',0);
      } else {
        let tierQty = $(_thisTierItem).data('qty');
        $('.tier-container quantity-input input.qty-input__input').val(parseInt(tierQty));
      }
      
      $(this).parents('.tier-pricing-block').find('.tier-item').removeClass('current');

      $(this).siblings('input').change(function() {
        
        if (!$(this).is(':checked') && !$(this).parents('.tier-item').hasClass('current')) {
           $(this).parents('.tier-pricing-block').find('.tier-item').removeClass('current');
          
        } else {
          $(this).parents('.tier-item').addClass('selected current');
          $(this).parents('.tier-item').prevAll().addClass('selected');
          var prevWidth = 0;

          $(this).parents('.tier-item').prevAll().each(function(e) {
            prevWidth += $(this).width() + 2;
          });

          $(this).parents('.tier-pricing-block').find('.progress-line div').css('width', prevWidth + 2 + $(this).parents('.tier-item').width());
          $(this).parents('.tier-item').nextAll().removeClass('selected current');

          let currentPrice = $('.product-price .price__default .price__current').data('price');
          let discountPerc = $(this).parents('.tier-item').data('discount-perc');
          let currentPriceReady = parseInt(currentPrice)/100;
          let discountReady = currentPriceReady / 100 * parseInt(discountPerc);
          let newPrice = currentPriceReady - discountReady;
          $('.product-price .price__default .price__current').html('$' + newPrice.toFixed(2));
        }
      });
    });
  });

  let tierBreaks = [];
  tierBreaks.push(1);
  $('.tier-item').each(function () {
    let tierQty = $(this).data('qty');
    tierBreaks.push(parseInt(tierQty));
  });

  $('.tier-container quantity-input input.qty-input__input').change(function () {

    let valueQty = $(this).val();

    var closestBreak = 1;
    for (let idx = 0; idx < tierBreaks.length; idx++) {
      if (valueQty >= tierBreaks[idx]) {
        closestBreak = tierBreaks[idx];
      }
    }

    if (closestBreak === 1) {
      $('.tier-item').removeClass('selected current');
      $('.tier-pricing-block').find('.progress-line div').css('width',0);
      $('.tier-item[data-qty="' + tierBreaks[1] + '"]').find('input').prop('checked', false);

      let currentPrice = $('.product-price .price__default .price__current').data('price');
      let currentPriceReady = parseInt(currentPrice)/100;
      $('.product-price .price__default .price__current').html('$' + currentPriceReady.toFixed(2));
    } else {

      let neededBreak = $('.tier-item[data-qty="' + closestBreak + '"]');

      if (!$(neededBreak).hasClass('current')) {
        $(neededBreak).addClass('selected current');
        $(neededBreak).find('input').prop('checked', true);
        $(neededBreak).prevAll().addClass('selected');
        $(neededBreak).prevAll().removeClass('current');
        var prevWidth = 0;
        
        $(neededBreak).prevAll().each(function(e) {
          prevWidth += $(neededBreak).width() + 2;
        });
  
        $(neededBreak).parents('.tier-pricing-block').find('.progress-line div').css('width', prevWidth + 2 + $(neededBreak).width());
        $(neededBreak).nextAll().removeClass('selected current');

        let currentPrice = $('.product-price .price__default .price__current').data('price');
        let discountPerc = $(neededBreak).data('discount-perc');
        let currentPriceReady = parseInt(currentPrice)/100;
        let discountReady = currentPriceReady / 100 * parseInt(discountPerc);
        let newPrice = currentPriceReady - discountReady;
        $('.product-price .price__default .price__current').html('$' + newPrice.toFixed(2));
      }
    }
  });
  // 1212991144434683 2 start
  $(window).on('on:variant:change', function(e) {
    const variantId = e.detail.variant.id;
    $('.cb-variant-short-description:not(.hidden)').addClass('hidden');
    $(`.cb-variant-short-description[data-variant-description="${variantId}"]`).removeClass('hidden');
  });
  // 1212991144434683 2 end
  $('.cb-testimonials').each(function() {
     const $section = $(this);
    const $wrapper = $section.find('.testimonials-carousel-wrapper');
    const $track = $section.find('.testimonials-carousel__track');

    if (!$track.length || !$wrapper.length) return;

    const MOBILE_BREAKPOINT = 767;
    const $originals = $track.find('.testimonials-carousel__slide').slice();

    if (!$originals.length) return;

    const $dotsWrap = $section.find('.testimonials-carousel__dots');
    const $dots = $dotsWrap.find('.testimonials-carousel__dot');

    let mode = null;
    let scrollHandler = null;

    function removeClones() {
      $track.find('[data-clone]').remove();
    }
    function startMarquee() {
      $track.removeClass('is-marquee');
      void $track[0].offsetWidth;
      $track.addClass('is-marquee');
    }

    function stopMarquee() {
      $track.removeClass('is-marquee');
    }
    function buildLoop() {
      removeClones();
      const gap = parseFloat($track.css('column-gap') || $track.css('gap')) || 0;
      let baseWidth = 0;
      $originals.each(function() {
        baseWidth += $(this).outerWidth() + gap;
      });
      const needed = Math.max(
        1,
        Math.ceil(($wrapper.outerWidth() * 1.5) / baseWidth)
      );
      for (let i = 1; i < needed; i++) {
        $originals.each(function() {
          const $clone = $(this).clone();
          $clone.attr('data-clone', '').attr('aria-hidden', 'true');
          $track.append($clone);
        });
      }
      $track.children().each(function() {
        const $clone = $(this).clone();
        $clone.attr('data-clone', '').attr('aria-hidden', 'true');
        $track.append($clone);
      });
      startMarquee();
    }

    function setActiveDot(index) {
      $dots.each(function(i) {
        const $dot = $(this);
        const active = i === index;
        $dot.toggleClass('is-active', active);
        if (active) {
          $dot.attr('aria-current', 'true');
        } else {
          $dot.removeAttr('aria-current');
        }
      });
    }

    function buildMobile() {
      removeClones();
      $dots.each(function(i) {
        $(this).off('click').on('click', function() {
            const target = $originals.eq(i);
            if (target.length) {
              $track.stop().animate({
                scrollLeft: target[0].offsetLeft
              }, 400);
            }
          });
      });

      scrollHandler = function() {
        const center = $track.scrollLeft() + $track.innerWidth() / 2;
        let closest = 0;
        let closestDist = Infinity;
        $originals.each(function(i) {
          const slideCenter = this.offsetLeft + $(this).outerWidth() / 2;
          const dist = Math.abs(slideCenter - center);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });

        setActiveDot(closest);
      };
      $track.on('scroll', scrollHandler);
      setActiveDot(0);
      $track.scrollLeft(0);
    }

    function teardownMobile() {
      if (scrollHandler) {
        $track.off('scroll', scrollHandler);
        scrollHandler = null;
      }
      $dots.off('click');
    }

    function applyTestimonialsMode() {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      const next = isMobile ? 'mobile' : 'marquee';
      if (next === mode) {
        if (next === 'marquee') {
          buildLoop();
        }
        return;
      }

      if (mode === 'mobile') {
        teardownMobile();
      }

      mode = next;

      if (mode === 'marquee') {
        buildLoop();
      } else {
        buildMobile();
      }
    }

    applyTestimonialsMode();

    let resizeTimer;

    $(window).on('resize', function() {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function() {
        applyTestimonialsMode();
      }, 250);
    });
  });
})(jQuery);

if (document.querySelector('.cb-template-page-free-sample')){
  let freeSamplesFormSelect = false;
  const freeSamplesFormObserver = new MutationObserver((mutations, obs) => {
    const element = document.querySelector('[data-forms-id="forms-root-502364"] form-embed');
    if (element && freeSamplesFormSelect === false) {
      freeSamplesFormSelect = true;
      element.shadowRoot.querySelector('[class*="textBody"]').textContent = 'We offer a free sample Cover for any Healthcare, Educational or Industrial organization within the United States of America. We would like you to experience the ease of use, and effective protection our products offer. Fill out your details below and make sure to indicate the make and model of your device. Limited to quantity 1 per organization. '
      element.shadowRoot.querySelector('fieldset legend').style.display = 'none';
    }
  });
  freeSamplesFormObserver.observe(document.querySelector('.cb-template-page-free-sample'), {
    childList: true,
    subtree: true
  });
}

if (document.querySelector('.cb-template-page-healthcare')){
  let healthcareFormSelect = false;
  const healthcareFormObserver = new MutationObserver((mutations, obs) => {
    const element = document.querySelector('[data-forms-id="forms-root-502364"] form-embed');
    if (element && healthcareFormSelect === false) {
      healthcareFormSelect = true;
      element.shadowRoot.querySelector('[class*="textBody"]').textContent = 'We offer a free sample Cover for any Healthcare, Educational or Industrial organization within the United States of America. We would like you to experience the ease of use, and effective protection our products offer. Fill out your details below and make sure to indicate the make and model of your device. Limited to quantity 1 per organization. '
      element.shadowRoot.querySelector('fieldset legend').style.display = 'none';
    }
  });
  healthcareFormObserver.observe(document.querySelector('.cb-template-page-healthcare'), {
    childList: true,
    subtree: true
  });
}

if (document.querySelector('.cb-template-page-education')){
  let educationFormSelect = false;
  const educationFormObserver = new MutationObserver((mutations, obs) => {
    const element = document.querySelector('[data-forms-id="forms-root-550202"] form-embed');
    if (element && educationFormSelect === false) {
      educationFormSelect = true;
      element.shadowRoot.querySelector('fieldset legend').style.display = 'none';
    }
  });
  educationFormObserver.observe(document.querySelector('.cb-template-page-education'), {
    childList: true,
    subtree: true
  });
}
if (document.querySelector('.cb-template-product .cb-custom-inquiry')){
  let requestQuoteFormSelect = false;
  const requestQuoteFormObserver = new MutationObserver((mutations, obs) => {
    const element = document.querySelector('[data-forms-id="forms-root-550376"] form-embed');
    if (element && requestQuoteFormSelect === false) {
      requestQuoteFormSelect = true;
      const { productUrl } = document.querySelector('[data-forms-id="forms-root-550376"]').dataset;
      const form = element.shadowRoot;
      const productUrlInput = form.querySelector('[id="custom#product_url"]');
      productUrlInput.setAttribute('value', productUrl);
      productUrlInput.dispatchEvent(new Event('input', { bubbles: true }));
      productUrlInput.style.display = 'none';
      productUrlInput.closest('[class*="formFieldContainer"]').querySelector('label').style.display = 'none';
    }
  });
  requestQuoteFormObserver.observe(document.querySelector('.cb-template-product'), {
    childList: true,
    subtree: true
  });
}

/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Enterprise is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Enterprise is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Enterprise, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Enterprise:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Follows a 'code splitting' architecture.
 *  - Is completely custom built (no JS libraries other than instant.page)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Enterprise broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
 *  4.  on:line-item:change
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - product: the product object (includes a list of all variants)
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart. To listen for this, see the
 * on:line-item:change event.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the variant was added
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:line-item:change
 * -------------------------------------------------------------------------------------------------
 * Fires when the quantity of an item already in the cart is updated. Note, if the 'newQuantity' is
 * 0, this indicates the item was removed from that cart.
 *
 * Note, when adding a variant to the cart - this event will fire if that variant is already in the
 * cart (i.e. the quantity is incremented). In this situation, 'on:cart:add' will not fire.
 *
 * How to listen:
 * document.addEventListener('on:line-item:change', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the quantity change was completed
 *   - variantId: id of the variant that was just updated
 *   - newQuantity: new quantity of the line item
 *   - oldQuantity: old quantity of the line item
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes. See the 'Media Queries' section in this file
 * for more.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Enterprise utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 * =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Enterprise only has one third-party dependency: instant.page (https://instant.page/).
 *
 * It's included locally and is only active if it has been enabled in
 * 'Theme Settings > Advanced > Preload links on hover'.
 *
 * Instant.page is a JavaScript library that speeds up page loads by preloading links as soon as the
 * customer hovers over them.
 *
 *
 *
 * =================================================================================================
 * Code Splitting
 * =================================================================================================
 * We followed the ‘code splitting’ technique when building Enterprise.
 *
 * Code splitting consists in writing JavaScript (and CSS)in a modularized way within typically
 * small, more manageable files that can be loaded on-demand, as needed. The idea is to improve the
 * performance of our theme by reducing the amount of code that needs to be loaded upfront.
 *
 * If the customer is visiting a specific page of the theme that requires certain JavaScript
 * functionality, only the code needed for that page will be loaded, rather than one large
 * JavaScript file containing largely unused code. For example, the file media-gallery.js will
 * only be loaded if there is a media gallery on the page.
 *
 * Shopify uses HTTP/2, which is the newer version of the HTTP protocol used to deliver web content.
 * HTTP/2 supports multiplexing, which means that multiple requests can be sent over a single
 * connection at the same time - meaning multiple JS files are essentially served at the speed of a
 * single file.
 *
 * The only JS file which is served on every page in Enterprise is 'main.js'. Main.js contains
 * utility JS which is likely to be needed by many scripts. This is outlined more in the next
 * section.
 *
 *
 *
 * =================================================================================================
 * Utilities
 * =================================================================================================
 * Enterprise provides a few utility utilities, contained in main.js. Some of the key ones are
 * outlined below. See main.js for more.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 1) Lazy Loading
 * -------------------------------------------------------------------------------------------------
 * Lazy loading is a technique for delaying the loading of certain elements until they are needed,
 * which can help improve page load times.
 *
 * We use three functions used for lazy loading images and scripts in our theme:
 *
 *  - setImageSources function - copies the data-src and data-srcset attributes of lazy loaded
 *    images to their src and srcset attributes.
 *  - initLazyScript function - only loads a script when a specific element is scrolled into view.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) Cookies
 * -------------------------------------------------------------------------------------------------
 * Cookies are small pieces of data that can be stored on a user's computer. They can be useful for
 * tracking user activity, remembering user preferences or other similar purposes.
 *
 * We use three functions to manage cookies:
 *
 *  - setCookie function - sets a cookie with a given name, value and number of days until it
 *  should expire.
 *  - getCookie function - takes in the name of a cookie to retrieve its value.
 *  - deleteCookie function - takes in the name of a cookie to delete it.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) Media Queries
 * -------------------------------------------------------------------------------------------------
 * The theme creates a theme.mediaMatches object (in theme.liquid) for several key screen sizes
 * specified in our theme, and adds listeners for each media query.
 *
 * These are:
 *
 * mediaQueries: {
 *  sm: '(min-width: 600px)',
 *  md: '(min-width: 769px)',
 *  lg: '(min-width: 1024px)',
 *  xl: '(min-width: 1280px)',
 *  xxl: '(min-width: 1536px)',
 *  portrait: '(orientation: portrait)'
 * }
 *
 * If a breakpoint is crossed, the mediaMatches values are updated and an 'on:breakpoint-change'
 * event is dispatched.
 *
 * You can request the entire theme.mediaMatches object to check which media queries are currently
 * matched. In this case, the returned data will be an object with the names of the media queries as
 * keys, and boolean values indicating whether they are currently matched or not.
 *
 * Example:
 *
 * {
 *  sm: true,
 *  md: true,
 *  lg: true,
 *  xl: true,
 *  xxl: false,
 *  portrait: false
 * }
 *
 * You can reference a specific media query to check if it's currently matched by using:
 * theme.mediaMatches.lg.
 *
 * To check if you're on mobile you can use:
 * !theme.mediaMatches.md
 *
 * If you want to perform some action when the breakpoint changes, you can listen for the
 * breakpoint-change event on the window object.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  // your code here
 * });
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */
